module.exports = __webpack_public_path__ + "assets/events_election_plain.f87eb2bc.svg";